// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:12:49

export default {
  "id": "mega-ramp-car",
  "slug": "mega-ramp-car",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/0e92c03a0b9644909fb5e4ee3269ff46-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/0e92c03a0b9644909fb5e4ee3269ff46/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Mega Ramp Car",
      "description": "Mega Ramp Car is a game with maximum speed and huge jumps! Are you ready to make the biggest leap in history?\n\nMega Ramp Car Features\n- Realistic physics and sound effects.\n- Real car collection\n- This game allows you to perform amazing stunts on different jumps.\n- Complete multiple levels and game modes for non-stop fun!\n- You have to complete many challenging missions, which makes the game even more exciting.\n\nBuy new cars to win new races. ",
      "instructions": "Get ready for fun in the Mega Ramp Car! This addictive game allows you to drive cars and jump off big jumps.\nChoose your favorite car and complete different levels filled with huge jumps and cool stunts. Drive, drift, do tricks, it's all possible in this game.\n",
      "genres": [
        "Racing & Driving"
      ],
      "tags": [
        "car",
        "drift",
        "jumping"
      ]
    },
    "zh-CN": {
      "title": "超级坡道赛车",
      "description": "Mega Ramp Car是一款速度极限、跳跃巨大的游戏！你准备好在历史上实现最大的飞跃了吗？\n\nMega Ramp Car特色\n- 真实物理和音效。\n- 真实汽车收藏\n- 游戏允许你在不同的跳跃上完成惊人的特技。\n- 完成多个关卡和游戏模式，享受不间断的乐趣！\n- 你需要完成许多挑战性任务，使游戏更加刺激。\n\n购买新车来赢得新的比赛。",
      "instructions": "准备好在Mega Ramp Car中享受乐趣！这款令人上瘾的游戏让你驾驶汽车从大跳台跳下。\n选择你最喜欢的汽车，完成充满巨大跳台和酷炫特技的不同关卡。驾驶、漂移、做特技，这款游戏中一切皆有可能。",
      "genres": [
        "赛车与驾驶"
      ],
      "tags": [
        "汽车",
        "漂移",
        "跳跃"
      ]
    },
    "zh-TW": {
      "title": "超級斜坡車",
      "description": "Mega Ramp Car 是一款速度極速、大跳躍的遊戲！你準備好要創下歷史上的最大躍躍了嗎？\n\nMega Ramp Car 功能特色\n- 精準的物理和音效。\n- 真實汽車收藏。\n- 本遊戲讓你能在不同的跳躍上執行驚人的特技。\n- 結束多個等級和遊戲模式，享受不間斷的樂趣！\n- 你必須完成許多挑戰任務，讓遊戲更加刺激。\n\n購買新車輛來贏得新的比賽。",
      "instructions": "為了樂趣準備上！Mega Ramp Car 瘋狂遊戲讓您可以駕馭車輛從大彈跳中飛躍而出。\n選擇您喜愛的車輛，完成充滿巨大彈跳和酷炫特技的各種等級。駕駛、滑胎、玩花招，這個遊戲裡所有都有可能。",
      "genres": [
        "賽車與駕駛"
      ],
      "tags": [
        "車",
        "滑行",
        "跳躍"
      ]
    },
    "zh-HK": {
      "title": "超級斜坡車",
      "description": "Mega Ramp Car是一款速度極快、跳躍巨大的遊戲！你準備好創下歷史上的最大跳躍了嗎？\n\nMega Ramp Car特色\n- 真實的物理和音效。\n- 真實汽車收藏。\n- 本遊戲允許你在不同的跳躍上表演驚人的特技。\n- 結束多個關卡和遊戲模式，享受無休止的樂趣！\n- 你必須完成許多挑戰性任務，讓遊戲更加刺激。\n\n購買新車來贏取新比賽。",
      "instructions": "為了在Mega Ramp Car中享受樂趣做好準備！這款上癮遊戲讓你駕駛汽車並從大跳躍中跳出。\n選擇你喜愛的車輛，完成充滿巨大跳躍和酷炫特技的不同等級。駕駛、漂移、施展特技，這款遊戲裡一切皆可實現。",
      "genres": [
        "賽車及駕駛"
      ],
      "tags": [
        "車",
        "漂移",
        "跳躍"
      ]
    },
    "ja": {
      "title": "メガランプカーゲーム",
      "description": "Mega Ramp Carは、最大速度と巨大なジャンプを持つゲームです！歴史で最も大きな飛躍に挑戦する準備はできていますか？\n\nMega Ramp Carの特徴\n- 現実的な物理と音効果。\n- 現実の車のコレクション。\n- さまざまなジャンプで驚異的なスタントを披露できます。\n- 複数のレベルとゲームモードをクリアして、止まらない楽しみを満喫！\n- 多くの挑戦的なミッションをクリアしなければなりませんが、これがゲームをさらにエキサイティングにします。\n\n新しい車を購入して新しいレースに勝ちましょう。",
      "instructions": "マega Ramp Carでの楽しい遊びに備えてください！この中毒性のあるゲームでは、車を運転し、大きなジャンプから飛び降りることができます。\n\nお気に入りの車を選び、巨大なジャンプやクールなスタントが満載の様々なレベルをクリアしましょう。ドライブ、ドリフト、トラicks、このゲームではすべて可能です。",
      "genres": [
        "レーシング＆ドライビング"
      ],
      "tags": [
        "車",
        "ドリフト",
        "ジャンプ"
      ]
    },
    "ko": {
      "title": "메가 램프 카ー",
      "description": "Mega Ramp Car은 최대 속도와 거대한 점프를 자랑하는 게임입니다! 역사상 가장 큰 뛰침을 할 준비가 되셨나요?\n\nMega Ramp Car 특징\n- 실제적인 물리학 및 사운드 이펙트.\n- 실제 자동차 컬렉션\n- 다양한 점프에서 놀라운 스타일을 시연할 수 있습니다.\n- 여러 레벨과 게임 모드를 완료하여 끊임없는 재미를 즐겨보세요!\n- 많은 도전적인 미션을 완료하여 게임이 더욱 흥미롭게 됩니다.\n\n새 차량을 구매하여 새 경기에 참가하세요.",
      "instructions": "메가 램프 카arResult를 즐기기 위해 준비하세요! 이 유혹적인 게임에서는 차를 운전하고 높은 점프에서 떨어지는 것을 할 수 있습니다.\n귀하의 관심을 끄는 차를 선택하고 큰 점프와 예쁜 스타일리시한 퍼포먼스가 가득한 다양한 레벨을 완료하세요. 운전, 드리프트, 트릭을 해보세요. 이 게임에서 모든 것이 가능합니다.",
      "genres": [
        "레이싱 & 드라이빙"
      ],
      "tags": [
        "차",
        "드리프트",
        "점프"
      ]
    },
    "fr": {
      "title": "Voiture de Rampe Mega",
      "description": "Mega Ramp Car est un jeu avec la vitesse maximale et des sauts énormes ! Êtes-vous prêt à faire le plus grand saut de l'histoire ?\n\nFonctionnalités de Mega Ramp Car\n- Physiques et effets sonores réalistes.\n- Collection de voitures réelles\n- Ce jeu vous permet de réaliser des figures étonnantes sur différents sauts.\n- Complétez plusieurs niveaux et modes de jeu pour un divertissement sans fin !\n- Vous devez accomplir de nombreuses missions difficiles, ce qui rend le jeu encore plus captivant.\n\nAchetez de nouvelles voitures pour gagner de nouveaux courses.",
      "instructions": "Préparez-vous au plaisir dans le Mega Ramp Car ! Ce jeu accrocheur vous permet de conduire des voitures et de sauter des grandes bosses.\nChoisissez votre voiture préférée et terminez différents niveaux remplis de grandes bosses et de figures impressionnantes. Conduisez, glissez, faites des figures, tout est possible dans ce jeu.",
      "genres": [
        "Courses et conduite"
      ],
      "tags": [
        "car",
        "drift",
        "saut"
      ]
    }
  }
};
